<span class="action-button" [ngClass]="getClasses()" [ngbTooltip]="title" tabindex="0">
  <my-global-icon *ngIf="icon && !loading" [iconName]="icon"></my-global-icon>
  <my-small-loader [loading]="loading"></my-small-loader>

  <span *ngIf="label" class="button-label">{{ label }}</span>

  <ng-content></ng-content>
</span>
